import './spinner.scss';

interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  callback?: Function;
}

export const Spinner: React.FC<WrapperProps> = (attrs) => {
  return <div className="custom-spinner" {...attrs}></div>;
};
